module.exports = __webpack_public_path__ + "static/media/cmc.bcf4d815.webp";